import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { nguoiDungAPI, authAPI } from '../services/api';
import { toast } from 'react-toastify';
import { FiUser, FiMail, FiLock, FiSave } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const ProfilePage = () => {
  const { user, updateUser } = useAuth();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('info');
  const [loading, setLoading] = useState(false);

  const [profileData, setProfileData] = useState({
    hoTen: user?.hoTen || '',
    email: user?.email || ''
  });

  const [passwordData, setPasswordData] = useState({
    matKhauCu: '',
    matKhauMoi: '',
    xacNhanMatKhau: ''
  });

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'password') {
      setActiveTab('password');
    } else {
      setActiveTab('info');
    }
  }, [searchParams]);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await nguoiDungAPI.updateProfile(profileData);
      if (response.data.success) {
        updateUser(response.data.data);
        toast.success(t('profile.updateSuccess'));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || t('common.errorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (passwordData.matKhauMoi !== passwordData.xacNhanMatKhau) {
      toast.error(t('profile.passwordMismatch'));
      return;
    }

    if (passwordData.matKhauMoi.length < 8) {
      toast.error(t('profile.passwordTooShort'));
      return;
    }

    setLoading(true);
    try {
      await authAPI.changePassword({
        matKhauCu: passwordData.matKhauCu,
        matKhauMoi: passwordData.matKhauMoi
      });
      toast.success(t('profile.changePasswordSuccess'));
      setPasswordData({ matKhauCu: '', matKhauMoi: '', xacNhanMatKhau: '' });
    } catch (error) {
      toast.error(error.response?.data?.message || t('common.errorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <div style={{ display: 'flex', gap: '16px' }}>
            <button
              className={`btn ${activeTab === 'info' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setActiveTab('info')}
            >
              <FiUser /> {t('profile.tabInfo')}
            </button>
            <button
              className={`btn ${activeTab === 'password' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setActiveTab('password')}
            >
              <FiLock /> {t('profile.tabPassword')}
            </button>
          </div>
        </div>
        <div className="card-body">
          {activeTab === 'info' && (
            <form onSubmit={handleUpdateProfile} style={{ maxWidth: '500px' }}>
              <div className="form-group">
                <label>
                  <FiUser style={{ marginRight: '8px' }} />
                  {t('profile.fullName')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={profileData.hoTen}
                  onChange={(e) => setProfileData({ ...profileData, hoTen: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  <FiMail style={{ marginRight: '8px' }} />
                  {t('profile.email')}
                </label>
                <input
                  type="email"
                  className="form-control"
                  value={profileData.email}
                  onChange={(e) => setProfileData({ ...profileData, email: e.target.value })}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                <FiSave />
                {loading ? t('profile.saving') : t('profile.saveBtn')}
              </button>
            </form>
          )}

          {activeTab === 'password' && (
            <form onSubmit={handleChangePassword} style={{ maxWidth: '500px' }}>
              <div className="form-group">
                <label>{t('profile.currentPassword')}</label>
                <input
                  type="password"
                  className="form-control"
                  value={passwordData.matKhauCu}
                  onChange={(e) => setPasswordData({ ...passwordData, matKhauCu: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>{t('profile.newPassword')}</label>
                <input
                  type="password"
                  className="form-control"
                  value={passwordData.matKhauMoi}
                  onChange={(e) => setPasswordData({ ...passwordData, matKhauMoi: e.target.value })}
                  placeholder={t('profile.newPasswordPlaceholder')}
                  required
                />
              </div>
              <div className="form-group">
                <label>{t('profile.confirmNewPassword')}</label>
                <input
                  type="password"
                  className="form-control"
                  value={passwordData.xacNhanMatKhau}
                  onChange={(e) => setPasswordData({ ...passwordData, xacNhanMatKhau: e.target.value })}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                <FiLock />
                {loading ? t('profile.processing') : t('profile.changePasswordBtn')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
